$(document).on('click', '[data-object-target="orders"][data-object-set]', function (event) {
  event.preventDefault();
  $('#id_object_id').val($(this).attr('data-object-set'));
  $('#id_object_text').html($(this).attr('data-object-label')).removeClass('hide');
  $('[data-object-select] small').addClass('hide');
  $('[data-order-object-deselect]').removeClass('hide');
  $(this).closest('[data-reveal]').foundation('close');
});

$(document).on('click', '[data-order-object-deselect]', function (event) {
  event.preventDefault();
  $('#id_object_id').val('');
  $('#id_object_text').html('').addClass('hide');
  $('[data-object-select] small').removeClass('hide');
  $(this).addClass('hide');
});
